import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FAZILService, User } from 'src/app/core';
import { UIService } from 'src/app/core/services/ui.service';
import { DataAssistantListUX } from 'src/app/modelo/DataAssistantListUX';
import { DataAssistantUX } from 'src/app/modelo/DataAssistantUX';

import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { FazilComponent } from 'src/app/core/fazil-component';
import { MessageService } from 'primeng/api';
import { FormBuilder } from '@angular/forms';
import { Establishment } from 'src/app/modelo/Establishment';
import { EmissionPoint } from 'src/app/modelo/EmissionPoint';

@Component({
    selector: 'app-establecimientos',
    templateUrl: './establecimientos.component.html'})
export class EstablecimientosComponent extends FazilComponent {
    
    _titulo:string = "Establecimiento";
    _establecimientos:Establishment[] = [];
    
    _establecimientoSeleccionado:Establishment;
    
    _emissionPointSelected:EmissionPoint;
    
    _requerido:boolean = true;
    
    _soloLectura:boolean = false;
    
    _mostrarSecuencias = false;
    
    @Output() onChange = new EventEmitter<EmissionPoint>();
    
    constructor(
        public override uiService: UIService,
        public override messageService: MessageService,
        public override _formBuilder: FormBuilder
    ){
        super(uiService, messageService, _formBuilder);
        this.ui = uiService;
    }
    
    @Input()
    set establecimientos(values:Establishment[]){
        this._establecimientos = values.filter(e => e.habilitado == true);
    }
    
    get establecimientos(): Establishment[] {
        return this._establecimientos;
    }
    
    @Input()
    set establecimientoSeleccionado(values:Establishment){
        this._establecimientoSeleccionado = values;
    }
    
    get establecimientoSeleccionado(): Establishment {
        return this._establecimientoSeleccionado;
    }
    
    @Input()
    set requerido(value:boolean){
        this._requerido = value;
    }
    
    get requerido(): boolean {
        return this._requerido;
    }
    
    @Input()
    set puntoEmisionSeleccionado(values:EmissionPoint){
        this._emissionPointSelected = values;
    }
    
    get puntoEmisionSeleccionado(): EmissionPoint {
        return this._emissionPointSelected;
    }
    
    @Input()
    set titulo(value:string){
        this._titulo = value;
    }
    
    get titulo(): string {
        return this._titulo;
    }
    
    @Input()
    set soloLectura(value:boolean){
        this._soloLectura = value;
    }
    
    get soloLectura(): boolean {
        return this._soloLectura;
    }
    
    emitirPuntoEmisionEleccionado(){
        this.onChange.emit( this._emissionPointSelected );
    }
    
    @Input()
    set mostrarSecuencias(value:boolean){
        this._mostrarSecuencias = value;
    }
    
    get mostrarSecuencias(): boolean {
        return this._mostrarSecuencias;
    }
}
